import { Collection } from "@/core/magnet";

export default Collection.extend({
  url: "campaigns/links/metrics",
  parse: function (response) {
    return response.data;
  },
});
